module.exports = __webpack_public_path__ + "img/transport-1.af78840d.svg";